// extracted by mini-css-extract-plugin
export default {"divMain":"AboutUs_divMain__iyFcs"};